import { useState } from "react";
import WeatherWatchButton from "../../weather/commercial/WeatherWatchButton";
import WeatherIntelligenceReport from "../../weather/commercial/WeatherIntelligenceReport";
import { fetchPropertyWeatherReport } from "../../../weather/commercialWeatherApi";

export default function PropertyWeatherWatchSection({ property }) {
  const [reportOpen, setReportOpen] = useState(false);
  const [reportPayload, setReportPayload] = useState(null);
  const [reportLoading, setReportLoading] = useState(false);
  const [reportError, setReportError] = useState("");

  const propertyId = property?.id;
  const coordinates = property?.location;

  const loadReport = async () => {
    setReportLoading(true);
    setReportError("");
    try {
      const payload = await fetchPropertyWeatherReport(propertyId);
      setReportPayload(payload);
      setReportOpen(true);
    } catch (error) {
      setReportPayload(null);
      setReportError(error.message || "Unable to generate report.");
    } finally {
      setReportLoading(false);
    }
  };

  return (
    <section className="panel-card property-weather-watch">
      <p className="eyebrow">Commercial weather intelligence</p>
      <h3>Monitor & report</h3>
      <p className="muted">
        Save this property for weather-risk updates and generate a client-facing summary with source
        attribution and limitations.
      </p>

      <WeatherWatchButton
        targetType="property"
        targetId={propertyId}
        label={property?.title || `Property ${propertyId}`}
        latitude={coordinates?.latitude}
        longitude={coordinates?.longitude}
      />

      <button
        type="button"
        className="weather-btn weather-btn-secondary weather-btn--compact"
        disabled={!propertyId || reportLoading}
        onClick={loadReport}
      >
        {reportLoading ? "Generating…" : "Generate weather report"}
      </button>

      {reportError ? <p className="muted">{reportError}</p> : null}

      {reportOpen ? (
        <WeatherIntelligenceReport
          reportPayload={reportPayload}
          title={`Property ${propertyId}`}
        />
      ) : null}
    </section>
  );
}
